module.exports = __webpack_public_path__ + "static/media/background-13.0cb268f5.jpg";